import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static identifier = "sortable-upgrades"
  static targets = ["list", "item"]
  static values = { updateUrl: String }

  connect() {
    // Wait for SortableJS to be available
    if (!this.hasListTarget) return

    if (window.Sortable) {
      this.initializeSortable()
      return
    }

    // Retry after a short delay if SortableJS isn't loaded yet
    setTimeout(() => {
      if (window.Sortable) {
        this.initializeSortable()
      } else {
        console.error('SortableJS library not found')
      }
    }, 100)
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy()
    }
  }

  initializeSortable() {
    this.sortable = window.Sortable.create(this.listTarget, {
      animation: 150,
      ghostClass: 'sortable-ghost',
      chosenClass: 'sortable-chosen',
      dragClass: 'sortable-drag',
      handle: '.drag-handle',
      onEnd: (event) => {
        this.updateServerOrder()
      }
    })
  }

  updateServerOrder() {
    const upgradeOrder = this.itemTargets.map(item => item.dataset.upgradeType)

    fetch(this.updateUrlValue, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ upgrade_order: upgradeOrder })
    })
    .then(response => response.json())
    .then(data => {
      if (data.success) {
        this.showSuccessMessage(data.message)
      } else {
        this.showErrorMessage(data.message)
      }
    })
    .catch(error => {
      console.error('Error updating upgrade order:', error)
      this.showErrorMessage('Failed to save upgrade order')
    })
  }

  showSuccessMessage(message) {
    this.showFlashMessage(message, 'notice', 3000)
  }

  showErrorMessage(message) {
    this.showFlashMessage(message, 'alert', 5000)
  }

  showFlashMessage(message, type, duration) {
    const notificationsEnabled = document.body?.dataset?.notificationsEnabled !== 'false'
    if (!notificationsEnabled) {
      return
    }

    const flashContainer = document.getElementById('flash-messages')
    if (flashContainer) {
      const flashElement = document.createElement('div')
      flashElement.className = `flash-message ${type}`
      flashElement.textContent = message
      flashContainer.appendChild(flashElement)

      setTimeout(() => {
        flashElement.remove()
      }, duration)
    }
  }
}
